export const MEASUREMENT_STATUS = {
  DRAFT: "DRAFT",
  COMPLETED: "COMPLETED",
};

export const isDraftMeasurement = (measurement) =>
  measurement?.status === MEASUREMENT_STATUS.DRAFT;

export const buildAnthropometryHubPath = (
  patientId,
  { measurementId, mode } = {}
) => {
  const params = new URLSearchParams();
  if (mode === "new") {
    params.set("mode", "new");
  }
  if (measurementId != null) {
    params.set("measurementId", String(measurementId));
  }
  const query = params.toString();
  return `/patients/${patientId}/anthropometry${query ? `?${query}` : ""}`;
};
